import { createAction } from '@reduxjs/toolkit';
import { ISupplier } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_SUPPLIERS } from '../../../../common';

export const setSuppliers = createAction<ISupplier[]>(
  `${MN_SUPPLIERS}/${TYPE_LIST}/${ACT_SET}`,
);
